import React from "react";
import { Facebook, Instagram } from "lucide-react";
import { SOCIAL } from "../../lib/social";

/**
 * Renders the brand's Facebook + Instagram icons as outbound links.
 * Used in Footer, About page, and anywhere we want to advertise our
 * social presence.
 *
 * Props:
 *   size       – icon px (default 18)
 *   align      – "row" (footer) | "stack" (about/CTA)
 *   showLabels – render handle text next to icons (default false)
 *   testIdPrefix – data-testid prefix (default "social")
 */
export default function SocialIcons({
  size = 18,
  align = "row",
  showLabels = false,
  testIdPrefix = "social",
  className = "",
}) {
  const items = [
    { key: "fb",  ...SOCIAL.facebook,  Icon: Facebook  },
    { key: "ig",  ...SOCIAL.instagram, Icon: Instagram },
  ];
  return (
    <div className={`flex ${align === "stack" ? "flex-col gap-3" : "items-center gap-3"} ${className}`} data-testid={`${testIdPrefix}-icons`}>
      {items.map(({ key, url, label, handle, Icon }) => (
        <a
          key={key}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Follow CampCompass UK on ${label}`}
          data-testid={`${testIdPrefix}-${key}`}
          className="group inline-flex items-center gap-2 text-[#555] hover:text-[#ff4500] transition-colors"
        >
          <span className="border hairline rounded-full p-2 group-hover:border-[#ff4500] group-hover:bg-[#fff4ee] transition-colors">
            <Icon className="w-[18px] h-[18px]" style={{ width: size, height: size }} strokeWidth={1.7} />
          </span>
          {showLabels && (
            <span className="text-sm">
              <span className="block font-display">{label}</span>
              <span className="block mono text-xs text-[#888]">{handle}</span>
            </span>
          )}
        </a>
      ))}
    </div>
  );
}
